module.exports = __webpack_public_path__ + "img/services-details-1.e9a945e5.jpg";